import axios from 'axios';
import moment from 'moment';
import jwt_decode from "jwt-decode";
import * as msal from "@azure/msal-browser";
import {msalConfig , apiRequest } from "../auth-config";
import "./mockAPIs/mockServer"

export const baseURL = process.env.REACT_APP_CUSTOM_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000/v1/';
const singleton = Symbol();
const singleton_enforcer = Symbol();


class Axios {
    constructor(enforcer) {
        if (enforcer !== singleton_enforcer) {
            throw new Error('Cannot construct singleton. If you tried to using new <Class>() better do not use that');
        }
        this.session =  axios.create({
          baseURL: baseURL,
          timeout: 180000,       
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("auth_token")}`
        }
        });

        this.session.interceptors.request.use(this.handleSuccessRequest, this.handleErrorRequest)
        this.session.interceptors.response.use(this.handleSuccess, this.handleError)
    }

    static get instance() {
        // Try to get an efficient singleton
        // In development mode, always create the singleton
        if (!this[singleton] && (process.env.NODE_ENV === 'development' || localStorage.getItem("auth_token") || localStorage.getItem("guest"))) {
            this[singleton] = new Axios(singleton_enforcer);
        }

        return this[singleton];
    }
    handleSuccessRequest = async(request) => {
        // Skip MSAL token refresh in development mode
        if (process.env.NODE_ENV === 'development') {
            request.headers.Authorization = localStorage.getItem("auth_token")
            return request;
        }
        
        if(!localStorage.getItem("guest"))
        try{
            const pc = new msal.PublicClientApplication(msalConfig);
            let user =jwt_decode (localStorage.getItem("auth_token"));
            let expiry = moment(user.exp * 1000).diff(moment().add(2, 'minutes'))
            if(expiry<=0){
                user = jwt_decode(localStorage.getItem("userInfo"))
                try {
                    const token=await pc.acquireTokenSilent({...apiRequest,account:user})
                    if(token)
                    {
                    localStorage.setItem("auth_token",token.accessToken)
                    }
                }
                catch(error) {                
                    localStorage.clear()
                    window.location.reload()
                }
            }
        }
        catch(error){
            // In development, don't clear storage on MSAL errors
            if (process.env.NODE_ENV !== 'development') {
                localStorage.clear()
                window.location.reload()
            }
        }
        request.headers.Authorization = `Bearer ${localStorage.getItem("auth_token")}`
        return request;
    }

    handleErrorRequest = (error) => {
        return Promise.reject(error)
    }

    handleSuccess = (response) => {

        return response;
    }

    handleError = (error) => {
        document.body.classList.remove('loading-indicator')
        if (error.message === 'Network Error') {
            // The user doesn't have internet
            return Promise.reject(error.response)
        }
        try {
            switch (error.response.status) {
                case 400:
                    break
                case 401:
                    break
                case 404:
                    // Show 404 page
                    break
                case 500:
                    // Serveur Error redirect to 500
                    break
                default:
                    Promise.reject(error.response)
                    break
            }
        } catch (e) {
        }
        return Promise.reject(error.response)
    }

    get(...params) {
        return this.session.get(...params);
        // Promise.catch((resp) => { return Promise.reject(resp) })
        // return Promise
    };
    post(...params) {
        return this.session.post(...params)
    };
    put(...params) {
        return this.session.put(...params)
    };
    patch(...params) {
        return this.session.patch(...params)
    };
    remove(...params) {
        return this.session.remove(...params)
    };
    delete(...params) {
        return this.session.delete(...params)
    };
}

export default Axios;